export default __webpack_public_path__ + "static/media/NHL.690b6ae6.png";